import moment from "moment";
import { Logger } from '../utils/logger';
import { DashboardDateManager } from '../views/dashboard/dashboardManager';

// 🎯 THIN WRAPPER - All date logic delegated to dashboardManager
const dateManager = DashboardDateManager.getInstance();

export const getDateRange = (value: string): { from: string; to: string } => {
  Logger.log('🎯 MomentFun.getDateRange called with:', value);

  // 🎯 SINGLE SOURCE OF TRUTH - dashboardManager handles ALL date calculations
  const result = dateManager.calculateDateRange(value);

  Logger.log('✅ MomentFun.getDateRange returning:', result);
  return result;
};

export const getDaysDifference = (from: string, to: string): number => {
  return Math.abs(moment(to).diff(moment(from), 'days'));
};